import React from 'react';
import {connect} from "react-redux";
import { useTranslation } from 'react-i18next';
import Button from '../../../../../../../../../../components/button';
import Icon from '../../../../../../../../../../components/icon';
import SelectOneLabelPopup from '../../../../../../../sharing-details-popup/components/select-one-label-popup';
import Label from "../../../../../../../list-of-groups/components/label";
import {addToOtherLabel} from '../../../../../../../../../../../actions/contactDetailsActions';
import './index.css';

function SharingSettings (props) {

	const { t } = useTranslation();		
	const {
        findContactDetails,
        findLabels,
	    addToOtherLabel,
	    setAddToOtherLabel
    } = props;

	let filteredSystemsGroups = findLabels.systemGroups.filter(systemGroup => {
		return findContactDetails.labels.find(label => {
			if (systemGroup.id === label.id) {
				return systemGroup;
			} else {
				return null;
			}
		})
	});

    let filteredContactsGroups = findLabels.contactsGroups.filter(contactsGroup => {
        return findContactDetails.labels.find(label => {
            if (contactsGroup.id === label.id) {
                return contactsGroup;
            } else {
                return null;
            }
        })
    });

    const addToOtherLabelHandler = () => {
	    setAddToOtherLabel(true);
    };

	const cancelAddToOtherLabelHandler = () => {
		setAddToOtherLabel(false);
	};

    return (
        <div className={`sharing-settings${addToOtherLabel ? ' sharing-settings__add-to-other-label' : ''}`}>
	        {
		        !addToOtherLabel && <Button className="btn-responsive btn-link font-weight-normal text-left" onClick={addToOtherLabelHandler}>
			        <Icon className="mr-2" name="plus-circle"/>{t("addToAnotherLabel")}
		        </Button>
	        }
	        {
		        addToOtherLabel && <Button className="btn-responsive btn-link font-weight-normal text-left" onClick={cancelAddToOtherLabelHandler}>
			        <Icon className="mr-2" name="chevron-circle-left"/>{t("textCancel")}
		        </Button>
	        }
	        {
	            addToOtherLabel && <SelectOneLabelPopup/>
            }
            {
	            !addToOtherLabel && <div className="sharing-settings__labels-list">
		            {
			            filteredSystemsGroups.map((filteredLabel) => (
				            <Label
					            key={filteredLabel.id}
					            id={filteredLabel.id}
					            name={filteredLabel.name}
					            status={filteredLabel.status}
					            nbOfContact={filteredLabel.nbOfContact}
					            permission={filteredLabel.permission}
					            sharingPreview={filteredLabel.sharingPreview}
								sharingNumber={filteredLabel.sharingNumber}
								ownerId={filteredLabel.ownerId}
				            />
			            ))
		            }
		            {
			            filteredContactsGroups.map((filteredLabel) => (
				            <Label
					            key={filteredLabel.id}
					            id={filteredLabel.id}
					            name={filteredLabel.name}
					            status={filteredLabel.status}
					            nbOfContact={filteredLabel.nbOfContact}
					            permission={filteredLabel.permission}
					            sharingPreview={filteredLabel.sharingPreview}
								sharingNumber={filteredLabel.sharingNumber}
								ownerId={filteredLabel.ownerId}
				            />
			            ))
		            }
	            </div>
            }
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        findContactDetails: state.contactDetailsReducer.findContactDetails,
        findLabels: state.contactsGroupItemReducer.findLabels,
	    addToOtherLabel: state.contactDetailsReducer.addToOtherLabel
    }
};

const mapDispatchToProps = (dispatch) => {
	return {
		setAddToOtherLabel: (boolean) => dispatch(addToOtherLabel(boolean))
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(SharingSettings);